import React from 'react';
import CountUp from 'react-countup';
import vendorAssign from '../../../../../../../assets/custom/v2/vendor.svg'; // Adjust the path as necessary

const CustomCard = ({ cardData }) => {
  return (
    <div className="d-flex justify-content-between sla-card" style={{ gap: '10px' }}>
      <img src={cardData?.icon ?? vendorAssign} className="img-fluid" alt="" style={{ maxWidth: '45px', height: '45px' }} />

      <div className="text-end">
        <p className="text-black text-format-7 m-0">{cardData?.name}</p>
        {cardData?.count != null ? (
          <CountUp separator="" start={0} end={cardData?.count} duration={2} className="fw-bold text-format-11 m-0" />
        ) : (
          <p className="fw-bold text-format-11 m-0">-</p> // Showing dash when data is missing
        )}
      </div>
    </div>
  );
};

export default CustomCard;
